import { cn } from 'lib/helpers/utility';

const ViewsRow = ({ titled = false, tabs = false, children }) => (
  <div className={cn('flex w-full min-w-0 gap-2', tabs && 'h-full items-stretch')}>
    {/* A page's views may turn out empty; the divider then has nothing to set off. */}
    {titled && <span className="mr-1 h-4 w-px shrink-0 self-center bg-neutral-200 only:hidden" />}
    {children}
  </div>
);

export default ViewsRow;
